<template>
  <nav>
    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <v-menu class="ml-6" offset-y transition="slide-y-transition" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon large>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-list-item-title>{{ loginUser.firstName + ' ' + loginUser.lastName }}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <v-btn color="red" text @click="$keycloak.logoutFn" v-if="$keycloak.authenticated">Logout</v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" dark src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXRylJTyHTk4y_9HI5AkPTeNJH--7jBOS2eut1QFtXPAdVFhy1-pIIMOmMcOJt6Pwg0hc&usqp=CAU" app class="navApp">
      <template v-slot:prepend>
        <v-list-item class="px-2">

          <img src="../../public/gshlogo.png" height="35" width="40">

           <v-list-item-content>
            <v-list-item-title><span style="font-size:15px;padding-left:10px">Georgetown Specialist</span><br><span style="font-size:15px;padding-left:10px">Hospital (GSH)</span></v-list-item-title>

          </v-list-item-content>

        </v-list-item>
      </template>

      <v-divider></v-divider>
      <v-list nav>

        <v-list>
          <v-list-item v-for="item in overview" :key="item.title" link :to="item.path">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-list-group :value="false" prepend-icon="mdi-cog" v-if="$keycloak.realmAccess.roles.includes('admin')">
          <template v-slot:activator>
            <v-list-item-title>Settings</v-list-item-title>
          </template>

          <v-list-item v-for="item in manage" :key="item.title" link :to="item.path">
            <v-list-item-icon>

            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <v-icon>{{ item.icon }}</v-icon>{{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  data() {
      return {
        drawer: false,
      overview: [
        {title: 'Overview', icon: 'mdi-view-dashboard', path:'/' },
        {title: 'Alerts', icon: 'mdi-alert-box', path:'/alert' },
      ],
      manage: [
        {title: 'Seismic', icon: 'mdi-chevron-right', path:'/smp-data'},
        {title: 'Location', icon: 'mdi-chevron-right', path:'/location' },
      ],
      };
  },
  computed: {
    loginUser() {
      return this.$store.getters["loginUser/getDetails"];
    },
  },
  created: function() {
    this.$store.dispatch("loginUser/setCurrentUser", {
      firstName: this.$keycloak.tokenParsed.given_name,
      lastName: this.$keycloak.tokenParsed.family_name,
    }); 
},
}

</script>

<style>
nav {
  z-index: 150;
}
</style>